// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vy_a bhl_b bhl_we"};